import { useState, useEffect } from 'react'
import { getSearchUserAPI } from '../services/setting/attendance-noti'

export default function useSearchUser(search, orgId) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!search || !orgId) {
      setData([])
      return
    }

    const controller = new AbortController()
    const timeout = setTimeout(async () => {
      try {
        setLoading(true)

        const body = { search, orgId, page: 1, size: 20 }
        const resp = await getSearchUserAPI(body)

        if (resp?.status) {
          const newData = resp.result.map((d) => ({
            ...d,

            /* ===== AntD Select ===== */
            value: d.username,
            labelText: `${d?.code ?? ''} - ${d?.nameEn ?? ''} ${d?.surnameEn ?? ''} (${d?.nicknameEn ?? ''})`,
            label: `${d?.code ?? ''} - ${d?.nameEn ?? ''} ${d?.surnameEn ?? ''} (${d?.nicknameEn ?? ''})`,
          }))

          setData(newData)
        } else {
          setData([])
        }
      } catch (e) {
        if (e.name !== 'AbortError') {
          setData([])
        }
      } finally {
        setLoading(false)
      }
    }, 400) // ⭐ debounce 400ms

    return () => {
      clearTimeout(timeout)
      controller.abort()
    }
  }, [search, orgId])

  return { data, loading }
}
